import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonMultiFileUploadServiceSub } from 'src/app/commons/kymw00/pless-json-multi-file-upload-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { RegistCwsIconFileDataVo } from '../vo/regist-cws-icon-file-data.model'

/**
 * 別アイコンファイル情報登録
 *
 * @export
 * @class RegistCwsIconFileData
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistCwsIconFileData extends PlessJsonMultiFileUploadServiceSub<any> {
  private vo: RegistCwsIconFileDataVo;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistCwsIconFileData
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        IconCode: this.vo.iconCode,
        StartOrderCode: this.vo.startOrderCode,
        EndOrderCode: this.vo.endOrderCode,
        IconAlternativeText: this.vo.iconAlternativeText
      }
    });
  }

  /**
   * API呼び出し
   *
   * @memberof RegistCwsIconFileData
   */
  execute(vo: RegistCwsIconFileDataVo, fileList: File[], successFunc: Function = null): void {
    this.vo = vo;
    this.successFunc = successFunc;
    this.sendFile('registCwsIconFileData', this.getBody(), fileList);
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistCwsIconFileData
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
